import { derived, writable } from 'svelte/store';
import type { TChangeEvent } from '@casumo/fabric-fundamentals';

type TNotificationType = TChangeEvent['type'];
export type TNotificationStore = Record<TNotificationType, boolean>;

export const notificationStore = writable<TNotificationStore>({
    valuables: false,
    verification: false,
    transactions: false
});

const getNotificatioStateByType = (type: TNotificationType) =>
    derived(notificationStore, ($store: TNotificationStore) => $store[type]);

export const valuablesNotificationEnabled = getNotificatioStateByType('valuables');

export const verificationNotificationEnabled = getNotificatioStateByType('verification');

export const transactionsNotificationEnabled = getNotificatioStateByType('transactions');
